import React from "react";

function LogoSlider() {
  return (
    <div className="logos">
      <div className="logos-slide">
        <img alt="logo" src="/assets/img/logos/alive.jpg" />
        <img alt="logo" src="/assets/img/logos/archirodon.png" />
        <img alt="logo" src="/assets/img/logos/axi.png" />
        <img alt="logo" src="/assets/img/logos/borzesti.png" />
        <img alt="logo" src="/assets/img/logos/ceravagon.png" />
        <img alt="logo" src="/assets/img/logos/daswork.png" />
        <img alt="logo" src="/assets/img/logos/dentons.jpg" />
        <img alt="logo" src="/assets/img/logos/dohwa.jpg" />
        <img alt="logo" src="/assets/img/logos/event-stuff.png" />
        <img alt="logo" src="/assets/img/logos/jokey.jpg" />
        <img alt="logo" src="/assets/img/logos/lorencic.png" />
        <img alt="logo" src="/assets/img/logos/niczuk.png" />
        <img alt="logo" src="/assets/img/logos/reinert.png" />
        <img alt="logo" src="/assets/img/logos/returo.png" />
        <img alt="logo" src="/assets/img/logos/rocapital.png" />
        <img alt="logo" src="/assets/img/logos/ruck.jpg" />
        <img alt="logo" src="/assets/img/logos/sandori.jpg" />
        <img alt="logo" src="/assets/img/logos/tempus.jpg" />
        <img alt="logo" src="/assets/img/logos/tfb.png" />
        <img alt="logo" src="/assets/img/logos/turbo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_001_aco-gruppe7259.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_002_images.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_003_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_004_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_005_alcon.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_006_idR1cvaNiI.png" />
        <img alt="logo" src="/assets/img/logos/logo_008_01cada77a0a7d326d85b7969fe26a728.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_009_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_010_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_011_Auchan-Logo.wine.png" />
        <img alt="logo" src="/assets/img/logos/logo_012_new-logo-fb.png" />
        <img alt="logo" src="/assets/img/logos/logo_013_images.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_014_axa5054.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_015_banca-transilvania-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_016_McLaren-Logo-2002.jpg" />
        <img alt="logo" src="/assets/img/logos/mercedes-benz-logo-freelogovectors.net_.png" />
        <img alt="logo" src="/assets/img/logos/bmw.svg" />
        <img alt="logo" src="/assets/img/logos/logo_019_brd-logo-primary1.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_020_mohhvabthsw6nqyhfp3m.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_021_carrefour.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_022_HBO-Logo.wine.svg" />
        <img alt="logo" src="/assets/img/logos/honda.jpg" />
        <img alt="logo" src="/assets/img/logos/Kaufland_201x_logo.png" />
        <img alt="logo" src="/assets/img/logos/lidl_logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_026_hewitt-associates2849.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/logo_027_Aspo_logo_some.png" />
        <img alt="logo" src="/assets/img/logos/bancpost.png" />
        <img alt="logo" src="/assets/img/logos/logo_029_BASF-Logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_030_Brilliance-Symbol.png" />
        <img alt="logo" src="/assets/img/logos/logo_031_652fdc252b28e26669365f82_BusinessLease-LOGO-Landscape.png" />
        <img alt="logo" src="/assets/img/logos/logo_032_bristol-myers-squibb-logo-e1476302468899.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_033_bwin.png" />
        <img alt="logo" src="/assets/img/logos/logo_034_af2cdce0beb8270468c328785a95724a.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_035_logo07.jpg" />
        <img alt="logo" src="/assets/img/logos/chase-de-vere-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/logo_037_social.png" />
        <img alt="logo" src="/assets/img/logos/logo_038_Continental-logo-logotype.png" />
        <img alt="logo" src="/assets/img/logos/logo_039_23-Dacris.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_040_490d8e60e2c5b3eb5325037df652fff4.png" />
        <img alt="logo" src="/assets/img/logos/Daimler_logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_042_cau-letter-logo-design-in-illustration-logo-calligraphy-desi.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_043_danfoss7157.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/logo_044_free-dhl-express-3442895-2875356.png" />
        <img alt="logo" src="/assets/img/logos/logo_045_dpd-dynamic-parcel-distribution5336.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_046_ebe-letter-logo-design-in-illustration-logo-calligraphy-desi.jpg" />
        <img alt="logo" src="/assets/img/logos/ecolab-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_048_igdw9649hwlwh2mjitiq.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_049_e-on1236.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/eti_logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_051_eurofins-scientific1551.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_052_Europharm-Distributie-1200x545_c.jpg" />
        <img alt="logo" src="/assets/img/logos/eventim-international-vector-logo-2022-small.png" />
        <img alt="logo" src="/assets/img/logos/logo_055_Fox_International_Channels_logo_20130122.png" />
        <img alt="logo" src="/assets/img/logos/Fokker_official_logo.png" />
        <img alt="logo" src="/assets/img/logos/ey_logo.png" />
        <img alt="logo" src="/assets/img/logos/fresenius-medical-care-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/Fricke-Gruppe_logo.svg" />
        <img alt="logo" src="/assets/img/logos/logo_060_FrieslandCampina-Logo.wine.svg" />
        <img alt="logo" src="/assets/img/logos/logo_061_Logo-Garanti-Bank-300x225.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_062_Galika-Logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_063_Gazprom-logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_064_gea-engineering-new-20225715.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_065_gewiss-logo.png" />
        <img alt="logo" src="/assets/img/logos/gkn8045.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_067_glencore4479.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/logo_068_gmv_rgbredblack.png" />
        <img alt="logo" src="/assets/img/logos/grammer-ag-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/grant-thornton-vector-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_071_h_C3_BCnnebeck.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_072_39.Intersnack.png" />
        <img alt="logo" src="/assets/img/logos/logo_073_johnson-johnson-new-2023-vertical23760.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/logo_074_Logo_KLG_site.png" />
        <img alt="logo" src="/assets/img/logos/logo_075_untitled-2_79.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_076_logo_kruk-1.png" />
        <img alt="logo" src="/assets/img/logos/KWS_SAAT_AG_logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_078_lapp-logo-weg.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_079_leroy-merlin8331.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_080_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_081_limagrain-logo.png" />
        <img alt="logo" src="/assets/img/logos/madrivo.png" />
        <img alt="logo" src="/assets/img/logos/logo_083_logo_Manutan.jpg" />
        <img alt="logo" src="/assets/img/logos/maisadour-logo-rond.png" />
        <img alt="logo" src="/assets/img/logos/logo_085_689_marksandspencer.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_086_389b3b31-bcad-41ed-b875-5eb8b3388fec.jpeg" />
        <img alt="logo" src="/assets/img/logos/MedPark_Hospital.jpg" />
        <img alt="logo" src="/assets/img/logos/mega_image.png" />
        <img alt="logo" src="/assets/img/logos/logo_089_merXu.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_090_863968d4e6c26b27ab214a867a0f9c2c.png" />
        <img alt="logo" src="/assets/img/logos/logo_091_855_metro.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_092_Miele-Logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_093_Mirus_11191313.jpg" />
        <img alt="logo" src="/assets/img/logos/mks-instruments-vector-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_095_1630542150875.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_096_logo-mr-bricolage.jpg" />
        <img alt="logo" src="/assets/img/logos/nidec-corporation-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/logo_098_Novartis-Emblem.png" />
        <img alt="logo" src="/assets/img/logos/logo_099_ntn.svg" />
        <img alt="logo" src="/assets/img/logos/logo_100_snr.gif" />
        <img alt="logo" src="/assets/img/logos/logo_101_logo-fb.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_102_pepsico4720.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_103_Philips_Wordmark-ALI-global.webp" />
        <img alt="logo" src="/assets/img/logos/logo_104_blog-sub_new-logo-3550664.png" />
        <img alt="logo" src="/assets/img/logos/pwc.png" />
        <img alt="logo" src="/assets/img/logos/logo_106_Raiffeisen-Bank-International-Logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_107_reader-s-digest.svg" />
        <img alt="logo" src="/assets/img/logos/logo_108_og_image_personal_business_company_80_1200_90_bigger.png" />
        <img alt="logo" src="/assets/img/logos/Logo_Riello.png" />
        <img alt="logo" src="/assets/img/logos/logo_110_rossmann2254.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_111_sandoz-new9018.logowik.com.webp" />
        <img alt="logo" src="/assets/img/logos/logo_112_SEC_Logotype_2.png" />
        <img alt="logo" src="/assets/img/logos/logo_113_sensata-technologies3812.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_114_Sixt-Logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_115_sofmedica-vert-albastru-16-jpg-webp.webp" />
        <img alt="logo" src="/assets/img/logos/logo_116_770_sodexo.jpg" />
        <img alt="logo" src="/assets/img/logos/stada-logo.png" />
        <img alt="logo" src="/assets/img/logos/sun-chemical-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/logo_119_sun_wave_pharma_logo.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_120_LOGO.svg" />
        <img alt="logo" src="/assets/img/logos/logo_121_Syngenta-Logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_122_Takata-logo.jpg" />
        <img alt="logo" src="/assets/img/logos/TakkoLogo.png" />
        <img alt="logo" src="/assets/img/logos/terapia-sa-a-sun-pharma-company-logo-vector.png" />
        <img alt="logo" src="/assets/img/logos/logo_126_hackett-logo-site-image-yoast.png" />
        <img alt="logo" src="/assets/img/logos/logo_127_novica-dve-naslovnica.jpg" />
        <img alt="logo" src="/assets/img/logos/TMF_Group.png" />
        <img alt="logo" src="/assets/img/logos/logo_129_trumpf8115.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_130_20130819104932_21TSB_logo_2013.svg" />
        <img alt="logo" src="/assets/img/logos/umeb.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_132_Unimasters.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_133_images.png" />
        <img alt="logo" src="/assets/img/logos/logo_134_aSbXoxsHyN-Xb2gfiW4rQmI0rOyixjexha8YOdJsClDhUDl9LzsWplmuNyxe.png" />
        <img alt="logo" src="/assets/img/logos/logo_135_vertis_logo_hi-res_trasparent-300x225.png" />
        <img alt="logo" src="/assets/img/logos/logo_136_Velcro-We-R-the-World-Press-and-News.jpg.optimal.jpg" />
        <img alt="logo" src="/assets/img/logos/vitesco.png" />
        <img alt="logo" src="/assets/img/logos/volvo.png" />
        <img alt="logo" src="/assets/img/logos/wacker-chemie-ag-vector-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_140_Wegmann-Logo-e1484067709864.png" />
        <img alt="logo" src="/assets/img/logos/weidmuller-gruppe-vector-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_142_Whirlpool-Logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_143_winmasters-logo.png" />
        <img alt="logo" src="/assets/img/logos/logo_144_images.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_145_128699f55ba10f7d9ed14473de504540.jpg" />
        <img alt="logo" src="/assets/img/logos/logo_146_trademark.jpg" />
      </div>
    </div>
  );
}

export default LogoSlider;
